var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1293_11860",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.634216,
    y: 0.484558,
    width: 11.7736,
    height: 11.7736,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1293_11860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5209 10.2237L3.33222 8.49446V5.83314L1.63977 4.90107L6.5209 2.23975L11.402 4.90107V8.43314H10.6662V5.30578L9.70958 5.83314V8.49446L6.5209 10.2237ZM6.5209 6.71616L9.88128 4.90107L6.5209 3.08597L3.16053 4.90107L6.5209 6.71616ZM6.5209 9.38975L8.97373 8.06522V6.22559L6.5209 7.56239L4.06807 6.22559V8.06522L6.5209 9.38975Z",
    fill: "#4F0696"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHead);
export default __webpack_public_path__ + "static/media/head.718004871d8a7c9ed202ccc593d43d46.svg";
export { ForwardRef as ReactComponent };